import React, { useState, useEffect } from "react";
import { useStorage, handleDraftFiltering } from '../../Utils/Utils';
import { gicsSectors } from '../../Utils/DummyData';
import Table from "../../components/Table/Table"
import FlexWrapper from "../FlexWrapper";
import DraftsPeerReviewRow from "./DraftsPeerReviewRow"

const DraftsPeerReviewTable = ({ setPeerLoading, filters }) => {
	const [data, setData] = useState([])
	const [expandedRows, setExpandedRows] = useState([])
	const [tickers, setTickers] = useState([])

	const storage = useStorage();

	useEffect(() => {
		storage.getOrFetch("/crm/tickers").then(setTickers)
		storage.refresh("/documents/drafts")
			.then(filterSortAndSetData)
			.catch((err) => {
				console.error(err)
				setPeerLoading(false)
			});
		storage.watch("/documents/drafts", filterSortAndSetData);
		return () => storage.unwatch("/documents/drafts")
	}, [])

	useEffect(() => {
		refreshList()
	}, [filters])

	const filterSortAndSetData = (drafts) => {
		let sortedDrafts = drafts.filter((doc) => {
			if (!handleDraftFiltering(doc.date, doc.ticker, filters)) return false
			return doc.peerReview === "pending"
		}).sort((a, b) => {
			if (a.date > b.date) return -1
			else if (a.date < b.date) return 1
			else return 0
		})
		setData(sortedDrafts)
		setPeerLoading(false)
	}

	const refreshList = () => storage.refresh("/documents/drafts").then(filterSortAndSetData)

	const getImage = (t) => {
		const sector = gicsSectors.find(s => s.name === t)
		const theTicker = tickers && tickers.find(ticker => ticker.ric === t)

		if (theTicker) return theTicker.logo
		else if (sector) return sector.image
		else return ""
	}

	const headerWidths = ["180px", "200px", "225px", "225px", "240px", "180px"];
	const headers = ["Last Edited", "Coverage", "Template", "Requestor", "Compliance", "Actions"];

	const dataMap = data.map((document, idx) => {
		if (document) {
			return <DraftsPeerReviewRow
				data={document}
				idx={idx}
				tickers={tickers}
				expandedRows={expandedRows}
				setExpandedRows={setExpandedRows}
				getImage={getImage}
				refreshList={refreshList}
			/>
		}
	});

	return (
		<FlexWrapper direction="column" align="start" className="mb-xxl">
			<p className="font-weight-semi-bold mb-m">Peer Approval Requests {data && data.length ? "(" + data.length + ")" : ""}</p>
			<Table id="drafts-peer-review-table" headerWidths={headerWidths} minWidth={1250} headers={headers} dataMap={dataMap} />
		</FlexWrapper>
	);
}

export default DraftsPeerReviewTable;